import * as ScrollMagic from "scrollmagic";
import {ScrollMagicPluginIndicator} from "scrollmagic-plugins";
import $ from 'jquery';
ScrollMagicPluginIndicator(ScrollMagic);

const triggers = [...document.querySelectorAll('.animationTextBackground')];

const triggersSecond = [...document.querySelectorAll('.animationTextBackgroundSecond')];

if ($(window).width() < 992) {
//Mobile
    if (triggers.length > 0) {
        triggers.forEach(function (trigger) {
    
            // init controller
            var controller = new ScrollMagic.Controller();
            // build scene
            var scene = new ScrollMagic
                .Scene(
                    {triggerElement: trigger, duration: 450, offset: 170}
                )
                .addTo(controller)
                //.addIndicators()
                .on("progress", function (e) {
                    var container = e.currentTarget.triggerElement();
    
                    var target = container.querySelector('.animationTextMobile');
           
                    if (target) {
    
                        var translateY = 0;
                        var opacity = 1;
    
                        translateY = translateY + ((e.progress.toFixed(3) * 70));
                        var opacityShift = 0;
                        opacityShift = opacityShift + ((e.progress.toFixed(3) * 1));
    
                        target.style.transform = "translateY(" + (translateY) + "px)";
                        target.style.opacity = (opacity - opacityShift);
    
                    }
            
                });
        });
    }
    if (triggersSecond.length > 0) {
        triggersSecond.forEach(function (trigger) {
    
            // init controller
            var controller = new ScrollMagic.Controller();
            // build scene
            var scene = new ScrollMagic
                .Scene(
                    {triggerElement: trigger, duration: 600, offset: 350}
                )
                .addTo(controller)
                //.addIndicators()
                .on("progress", function (e) {
                    var targetSecondMobile = document.querySelector('.animationTextMobile2');
    
             
                    if (targetSecondMobile) {
    
                        var translateY = 0;
                        var opacity = 1;
    
                        translateY = translateY + ((e.progress.toFixed(3) * 100));
                        var opacityShift = 0;
                        opacityShift = opacityShift + ((e.progress.toFixed(3) * 1));
    
                        targetSecondMobile.style.transform = "translateY(" + (translateY) + "px)";
                        targetSecondMobile.style.opacity = (opacity - opacityShift);
    
                    }
                });
        });
    }
    
 }
 else {
//Desktop
    if (triggers.length > 0) {
        triggers.forEach(function (trigger) {
    
            // init controller
            var controller = new ScrollMagic.Controller();
            // build scene
            var scene = new ScrollMagic
                .Scene(
                    {triggerElement: trigger, duration: 600, offset: 270}
                )
                .addTo(controller)
                //.addIndicators()
                .on("progress", function (e) {
                    var container = e.currentTarget.triggerElement();
    
                    var target = container.querySelector('.animationText');
                    var targetSecond = document.querySelector('.animationTextSecond');
              
             
                    if (target) {
    
                        var translateY = 0;
                        var opacity = 1;
    
                        translateY = translateY + ((e.progress.toFixed(3) * 100));
                        var opacityShift = 0;
                        opacityShift = opacityShift + ((e.progress.toFixed(3) * 1));

    
                        target.style.transform = "translateY(" + (translateY) + "px)";
                        target.style.opacity = (opacity - opacityShift);
    
                    }
            
                });
        });
    }


    if (triggersSecond.length > 0) {
        triggersSecond.forEach(function (trigger) {
    
            // init controller
            var controller = new ScrollMagic.Controller();
            // build scene
            var scene = new ScrollMagic
                .Scene(
                    {triggerElement: trigger, duration: 600, offset: 450}
                )
                .addTo(controller)
                //.addIndicators()
                .on("progress", function (e) {
                    var targetSecond = document.querySelector('.animationTextSecond');
              
             
                    if (targetSecond) {
    
                        var translateY = 0;
                        var opacity = 1;
    
                        translateY = translateY + ((e.progress.toFixed(3) * 100));
                        var opacityShift = 0;
                        opacityShift = opacityShift + ((e.progress.toFixed(3) * 1));
    
                        targetSecond.style.transform = "translateY(" + (translateY) + "px)";
                        targetSecond.style.opacity = (opacity - opacityShift);
    
                    }
                });
        });
    }
 }

 